module.exports = __webpack_public_path__ + "static/header-bg-e7788e6b1358f6941e7beb87ccc7fedc.png";